import React, { useState, useEffect } from "react";
import { Link } from "gatsby";
import { Col, Container, Row } from "react-bootstrap";
import {
  MainLogo,
  Hambuger,
  MainLogoWhite,
  MobileContactLogo,
} from "../../../../app-constants";

function Header({ bgcolor, lang, phone, handleShow }) {
  const [isActive, setIsActive] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 10;
      if (isScrolled !== scrolled) {
        setScrolled(!scrolled);
      }
    };
    document.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, [scrolled]);

  const handleClick = (event) => {
    event.currentTarget.classList.toggle("active");
    document.body.classList.toggle("active");
    setIsActive((current) => !current);
  };
  let className = "tekrevol_header tekrevol-lp-header";
  if (bgcolor === "white") {
    className = "tekrevol_header white tekrevol-lp-header";
  }
  return (
    <div className={`${scrolled ? "active" : ""} ${className}`}>
      <Container className="h-100">
        <Row className="h-100 justify-content-between">
          <Col xs={6} md={2} lg={2} xl={2} xxl={2} className="mt-auto mb-auto">
            <div className="tekrevol_logo">
              <Link to="/" aria-label="Go to home page">
                {bgcolor !== "white" || scrolled ? MainLogo : MainLogoWhite}
              </Link>
            </div>
          </Col>
          <Col xs={6} md={4} lg={3} xl={2} xxl={2} className="my-auto text-end">
            <button
              onClick={handleShow}
              style={{ background: "#f47a14", color: "#fff" }}
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Join Community
            </button>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Header;
